<template>
  <div class="loading" ref="loading" id="loading">
    <el-carousel trigger="click" height="16em">
      <el-carousel-item v-for="item in banners" :key="item.index">
        <el-image
          style="width: 100%; height: auto"
          :src="baseSrc + item.src"
          fit="fit"></el-image>
      </el-carousel-item>
    </el-carousel>
    <transition name="el-zoom-in-center">
      <div v-show="shows[0]" class="transition-box">
        <h1><b>服务项目</b></h1>
        <p class="mark"><span></span>可信赖<span></span>智能化<span></span>高品质<span></span>全生命周期服务</p>

        <el-carousel trigger="click" height="16em" :interval="2000" >
          <el-carousel-item v-for="items in servers" :key="items.index">
            <div class="type">
              <div class="box" v-for="item in items" :key="item.index" @click="toServersInfo(item.id)">
                <div>
                  <img class="img" :src="baseSrc + item.picture">
                  <b class="name">{{item.name}}</b>
                  <p class="description">{{item.synopsis}}</p>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="shows[1]" class="transition-box">
        <h1><b>车型展示</b></h1>
        <p class="mark"></p>
        <el-carousel :interval="4000" type="card" height="14em">
          <el-carousel-item v-for="item in cars" :key="item.index">
            <div class="car">
              <div class="car_img">
                <img :src="baseSrc + item.picture">
              </div>
              <div class="car_description">
                <p>{{item.name}}</p>
                <p>{{item.load}}</p>
                <p>长×宽×高</p>
                <p>{{item.size}}</p>
                <p>{{item.introduce}}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="shows[2]" class="transition-box">
        <h1><b>工程案例</b></h1>
        <p class="mark">
          <span></span>20+行业领域<span></span>50+国家<span></span>5000+高端客户
          <el-button class="more" @click="to('cases')">全部案例</el-button>
        </p>
        <div class="cases">
          <div class="box" v-for="item in cases" :key="item.index" @click="toInfo(item.id,'cases')">
            <div>
              <img class="img" :src="baseSrc + item.coverPicture">
              <b class="name" style="border: 0">{{item.title}}</b>
              <p class="description">{{item.content}}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="el-zoom-in-center">
      <div v-show="shows[3]" class="transition-box">
        <h1><b>新闻中心</b></h1>
        <p class="mark">
          <span></span>关注客户<span></span>砥砺前行<span></span>聚焦行业<span></span>传播价值
          <el-button class="more" @click="to('news')">全部新闻</el-button>
        </p>
        <div class="news">
          <div class="n_box" v-for="item in news" :key="item.index" @click="toInfo(item.id,'news')">
            <div>
              <div>
                <img class="img" :src="baseSrc + item.coverPicture">
              </div>
              <p><b>{{item.title}}</b></p>
              <p>{{item.releaseTime}}</p>
              <p>{{item.content}}</p>
            </div>
          </div>
        </div>
        <div style="height: 1em">
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import request from '@/api/request'
export default {
  name: 'index',
  data () {
    return {
      baseSrc: process.env.BASE_API,
      banners: [],
      servers: [],
      cars: [],
      cases: [],
      news: [],
      shows: [false, false, false, false]
    }
  },

  created () {
    // 初始化数据
    request({
      url: 'banner/findBannerList?name=home',
      method: 'GET'
    }).then(data => {
      if (data.data.code === 200) {
        const banners = []
        const resources = data.data.data.tableData[0].resources
        resources.forEach(resource => {
          banners.push({src: resource.path})
        })
        this.banners = banners
      }
    })
    request({
      url: 'serviceItems/findServiceItemsList',
      method: 'GET'
    }).then(data => {
      if (data.data.code === 200) {
        const table = data.data.data.tableData
        const arr = []
        let temArr = []
        for (let i = 0; i < table.length; i++) {
          // 服务类型描述优化
          if (table[i].synopsis.length > 50) {
            table[i].synopsis = table[i].synopsis.substring(0, 50) + '...'
          }
          temArr.push(table[i])
          if ((i + 1) % 3 === 0) {
            arr.push(temArr)
            temArr = []
          }
        }
        this.servers = arr
      }
    })
    request({
      url: 'vehicle/findVehicleList',
      method: 'GET'
    }).then(data => {
      if (data.data.code === 200) {
        this.cars = data.data.data.tableData
      }
    })
    request({
      url: 'caseNew/findCaseNewList?status=0&currentPage=0&pageSize=3',
      method: 'GET'
    }).then(data => {
      if (data.data.code === 200) {
        this.cases = data.data.data.tableData
        // 车型描述优化
        for (let i = 0; i < this.cases.length; i++) {
          this.cases[i].content = this.cases[i].content.replace(/<\/?[^>]*>/g, '')
          this.cases[i].content = this.cases[i].content.replace(/[ | ]*\n/g, '\n')
          this.cases[i].content = this.cases[i].content.replace(/&nbsp;/ig, '')
          if (this.cases[i].content.length > 100) {
            this.cases[i].content = this.cases[i].content.substring(0, 100) + '...'
          }
        }
      }
    })
    request({
      url: 'caseNew/findCaseNewList?status=1&currentPage=0&pageSize=4',
      method: 'GET'
    }).then(data => {
      if (data.data.code === 200) {
        this.news = data.data.data.tableData
        // 车型描述优化
        for (let i = 0; i < this.news.length; i++) {
          this.news[i].content = this.news[i].content.replace(/<\/?[^>]*>/g, '')
          this.news[i].content = this.news[i].content.replace(/[ | ]*\n/g, '\n')
          this.news[i].content = this.news[i].content.replace(/&nbsp;/ig, '')
          if (this.news[i].content.length > 180) {
            this.news[i].content = this.news[i].content.substring(0, 180) + '...'
          }
        }
      }
    })
  },
  mounted () {
    const self = this
    self.lazyLoad()
    document.onscroll = function () {
      self.lazyLoad()
    }
  },
  methods: {
    // 页面懒加载
    lazyLoad () {
      // 当前窗口的高度
      const windowHeight = document.documentElement.clientHeight
      // 当前滚动条从上往下滚动的距离
      const scrollTop = document.documentElement.scrollTop
      // 导航栏高度
      if (this.$refs.loading === undefined) return
      const headerHeight = this.$refs.loading.offsetParent.firstElementChild.firstChild.firstChild.offsetHeight
      const loadings = this.$refs.loading.children
      const shows = []
      let offsetHeight = 0
      for (let i = 0; i < loadings.length; i++) {
        // 当前文档的高度
        const currentOffsetHeight = loadings[i].offsetHeight
        offsetHeight += currentOffsetHeight
        // console.debug('currentOffsetHeight', currentOffsetHeight)
        // console.debug('headerHeight', offsetHeight + headerHeight)
        // console.debug('scrollTop', windowHeight + scrollTop)
        if (offsetHeight + headerHeight < windowHeight + scrollTop) {
          shows.push(true)
        } else {
          shows.push(false)
        }
      }
      this.shows = shows
    },
    toInfo (id, path) {
      let link = {}
      if (path === 'cases') {
        link = {
          path: '/info',
          query: {
            id: id,
            path: '/cases',
            name: '案例详情',
            parentName: '工程案例'
          }
        }
        this.$emit('to', 'cases')
      } else if (path === 'news') {
        link = {
          path: '/info',
          query: {
            id: id,
            path: '/news',
            name: '新闻详情',
            parentName: '新闻中心'
          }
        }
        this.$emit('to', 'news')
      }
      this.$router.push(link)
    },
    to (path) {
      this.$emit('to', path)
    },
    toServersInfo (id) {
      this.$emit('to', 'servers')
      this.$router.push({
        path: '/serversInfo',
        query: {
          id: id
        }
      })
    }
  }
}
</script>

<style scoped>
  .loading {
    padding-top: .1em;
  }
  h1 {
    color: #61a60e;
    margin-bottom: .3em;
    padding-top: 1em;
  }
  .mark {
    font-size: .8em;
    color: rgba(0,0,0,.4);
    margin-bottom: 3em;
  }
  .mark > span {
    margin-left: 1em;
    margin-right: .3em;
    display: inline-block;
    height: .5em;
    width: .5em;
    border: .1em solid #61a60e;
    transform: rotate(45deg);
  }
  .type,.cases {
    text-align: left;
  }
  .cases > div {
    width: 31.9%;
    position: relative;
    justify-content: center;
    display: inline-block;
    overflow: hidden;
    height: 14em;
    cursor:pointer;
    margin-right: 1%;
    margin-bottom: 1%;
  }
  .type > div {
    width: 32.3%;
    position: relative;
    justify-content: center;
    display: inline-block;
    overflow: hidden;
    height: 14em;
    cursor:pointer;
    margin-right: 1%;
    margin-bottom: 1%;
  }
  .type > .box > div,.cases> .box > div {
    justify-content: center;
    display: inline-flex;
    align-items: flex-start;
    height: 100%;
    width: 100%;
  }
  .type > .box > div > img{
    height: 100%;
    width: 100%;
  }
  .cases > .box > div > img{
    width: 100%;
    height: 100%;
  }
  .name {
    position: absolute;
    color: #fff;
    -webkit-border-radius: 1em;
    -moz-border-radius: 1em;
    font-size: .8em;
    border-radius: 2em;
    border: .1em solid #fff;
    padding: .1em 1em;
    top:5em;
    text-align: center;
  }
  .type .box:hover .name{
    color: #61a60e;
    border: 0em solid #fff;
    transition: .4s;
    top:1em;
    font-size: 1.2em;
  }
  .type .description {
    font-size: .7em;
    color: #fff;
    width: 80%;
    position: absolute;
    top: 25em;
  }
  .type .box:hover .description{
    top: 5em;
    transition: .5s;
  }
  .cases .box:hover .name{
    font-size: 1em;
    color: #61a60e;
    border: 0em solid #fff;
    transition: .4s;
    top:1em;
  }
  .cases .description {
    font-size: .7em;
    color: #fff;
    width: 80%;
    position: absolute;
    top: 25em;
  }
  .cases .box:hover .description{
    top: 6em;
    transition: .5s;
  }
 .box:hover .img {
    transform: scale(1.2,1.2);
    filter: grayscale(80%);
    transition: .5s;
  }
  .car {
    text-align: left;
    height: 100%;
    background-color: #fff;
    display: flex;
  }
  .car_img {
    display: inline-block;
    width: 60%;
  }
  .car_img > img {
    width: 100%;
    height: 100%;
  }
  .car_description {
    width: 40%;
  }
  .car_description > p{
    font-size: .6em;
    padding-left: 1em;
    height: 1em;
  }
  .car_description > p:not(:first-child){
    padding-left: 2em;
  }
  .car_description > p:first-child{
    font-size: .8em;
    font-weight: bold;
  }
  .car_description > p:last-child{
    color: rgba(0,0,0,0.4);
  }
  .news {
    text-align: left;
    overflow: hidden;
  }
  .news > div {
    width: 22.5%;
    margin-left: 2%;
    position: relative;
    justify-content: center;
    display: inline-flex;
    overflow: hidden;
    cursor:pointer;
  }
  .news > .n_box > div > div:first-child {
    width: 100%;
    height: 14em;
    overflow: hidden;
  }
  .news > .n_box img {
    width: 100%;
    height: 100%;
  }
  .news > .n_box p {
    padding: 0 1em;
  }
  .news > .n_box p:nth-last-child(2),.news > .n_box p:last-child {
    color: rgba(0,0,0,0.4);
  }
  .n_box {
    font-size: .6em;
  }
  .n_box:hover {
    color: #61a60e;
    box-shadow: 0 0 25px -5px #ccc;
    transform: translateX(-0.2em) translateY(-0.2em);
  }
  .transition-box {
    transition: .6s;
    width: 96%;
    margin-left: 2%;
  }
  .transition-box > p{
    position: relative;
  }
  .more {
    position: absolute;
    top: 0;
    right: 3em;
    color: #61a60e;
    border: .1em solid #61a60e;
    font-size: .8em;
    border-radius: 2em;
    padding: 1em;
  }
  .more:hover {
    color: #fff;
    background-color: #61a60e;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue